import styled from '@emotion/styled'

import { Space } from '../../atoms'

export const StyledContainer = styled(Space)`
  color: var(--Graphite);
  background: var(--InfoBG);
  border: solid 1px var(--Info);
  border-radius: 4px;
`

export const StyledTableContainer = styled(Space)`
  background: #e7f1f7 0% 0% no-repeat padding-box;
`

export const StyledAttributesStack = styled(Space)`
  gap: 20px;
`
